import { useEffect, useRef } from 'react';
import { cidParts, emitToHost } from '../lib/bridge.js';

/**
 * Emits `conversation-opened` (chat-emp's own) and `active-channel` (stream-chat
 * parity) to the host when the active channel changes. Fires once per distinct
 * channel.
 */
export function useConversationOpened(channelId: string | undefined): void {
  const last = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (channelId && channelId !== last.current) {
      last.current = channelId;
      emitToHost('conversation-opened', { channelId });
      const { channelType, channelId: id } = cidParts(channelId);
      emitToHost('active-channel', { id, type: channelType });
    }
  }, [channelId]);
}
